import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { _ } from "../utils/i18n";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 80px 0 0 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 409px;
  padding: 20px;
  position: relative;
  background-color: rgb(6 6 43 / 20%);
  @media (max-width: 770px) {
    margin: 40px 0;
    padding: 20px 0;
    height: auto;
  }
`;
const FormWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  &:hover {
    padding: 20;
  }
  @media (max-width: 770px) {
    padding: 0 20px;
  }
`;
const Title = styled.h2`
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 2rem;
`;
const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  padding-bottom: 10px;
  @media (max-width: 770px) {
    flex-wrap: wrap;
    width: 100%;
  }
`;
const TextFieldStyle = styled((props) => <TextField {...props} />)`
  max-width: 290px;
  width: 100%;
  @media (max-width: 900px) {
    margin-bottom: 10px !important;
    max-width: none;
  }
`;
const CheckboxLabel = styled((props) => <FormControlLabel {...props} />)`
  font-style: italic;
`;

export default function SendForm({ url }) {
  const [state, setState] = React.useState({
    checkedA: false,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };
  return (
    <Container>
      <Helmet
        script={[
          {
            type: "text/javascript",
            innerHTML: `var cf7 = document.getElementById('form-cf7'); var sentCounter = 0; if(cf7 && sentCounter<1){ cf7Active(); }else{ window.addEventListener("scroll", cf7Activator, {passive: true}); } function cf7Activator(){ var elementExists = document.getElementById("form-cf7"); if(elementExists){ cf7Active(); window.removeEventListener("scroll", cf7Activator, {passive: true}); } } function onButtonClick() {
                     var message = Validate(document.getElementById("form-cf7"));
                     var errorMessage = document.getElementById("errorMessage");
                     if(message==''){
                     errorMessage.innerHTML = '';
                     }else{
                     errorMessage.innerHTML = message;
                     return false;
                     }
                     sentCounter++; var bttn = document.getElementById('submitCf7Button'); bttn.disabled = true; bttn.setAttribute('style','opacity:0.5;margin-top: 20px;border-radius: 50px;width: 150px;height: 40px'); bttn.innerHTML = 'Sender inn skjema...'; var xhttp = new XMLHttpRequest(); xhttp.onreadystatechange = function() { if (this.readyState === 4 && this.status === 200) {  if(this.responseText.includes("mail_sent")){ window.location.href = 'https://enklerevalg.no/takk-for-din-melding/'; } } }; xhttp.open("POST", "${url}", true); xhttp.send(new FormData(document.getElementById('form-cf7')));  } function cf7Active(){ document.getElementById('form-cf7').addEventListener('submit', replaceTheDefault, false); var inputs = document.querySelectorAll( '.inputfile' ); Array.prototype.forEach.call( inputs, function( input ) { var label = input.nextElementSibling, labelVal = label.innerHTML; input.addEventListener( 'change', function( e ) { var fileName = escape(this.value).split('%5C').pop(); label.innerHTML = unescape(fileName); }); }); } function replaceTheDefault(evt){ evt.preventDefault(); onButtonClick(); /*document.getElementById('form-cf7').removeEventListener('submit', replaceTheDefault, false); */ } var _validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png", '.doc','.docm','.docx','.docx','.pdf','.txt','.xls','.xlsx','xlsm'];
                     function emailIsValid (email) {
                       return /\\S+@\\S+\\.\\S+/.test(email)
                     }
                     function Validate(oForm) {
                         var arrInputs = oForm.getElementsByTagName("input");
                         for (var i = 0; i < arrInputs.length; i++) {
                             var oInput = arrInputs[i];
                             if (oInput.type == "file") {
                                 var sFileName = oInput.value;
                                 if (sFileName.length > 0) {
                                     var blnValid = false;
                                     for (var j = 0; j < _validFileExtensions.length; j++) {
                                         var sCurExtension = _validFileExtensions[j];
                                         if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                                             blnValid = true;
                                             break;
                                         }
                                     }

                                     if (!blnValid) {
                                         return "${_(
                                           "Bare bilder og dokumenter kan lastes opp. Vennligst sjekk vedlagte filer."
                                         )}";
                                     }
                                 }
                     //}else if(oInput.type === "email"){
                     //if (emailIsValid(oInput.value)===false) {
                     //    return "Skriv inn en riktig E-post"+oInput.value;
                     //}
                     }
                         }

                         return '';
                     }
                     `,
          },
        ]}
      />
      <FormWrapper>
        <Title>{_("Send oss en melding")}</Title>
        <form
          noValidate
          autoComplete="off"
          id="form-cf7"
          encType="multipart/form-data"
        >
          <RowContainer>
            <TextFieldStyle
              id="filled-textfield"
              label={_("Navn")}
              name="your-name"
              type="text"
              autoComplete="name"
              variant="filled"
              color="secondary"
            />
            <TextFieldStyle
              id="filled-email-input"
              label={_("E-postadresse")}
              type="email"
              name="your-email"
              autoComplete="email"
              color="secondary"
              variant="filled"
            />
          </RowContainer>
          <TextField
            id="filled-multiline-static"
            style={{ width: "100%" }}
            label={_("Melding")}
            multiline={true}
            rows="4"
            variant="filled"
            name="your-message"
            color="secondary"
          />
          <RowContainer>
            <CheckboxLabel
              control={
                <Checkbox
                  checked={state.checkedA}
                  onChange={handleChange}
                  name="checkedA"
                  color="secondary"
                />
              }
              label={_("Jeg godtar at MEV tar kontakt med meg per epost")}
            />

            <Button
              variant="contained"
              color="primary"
              size="medium"
              id="submitCf7Button"
              type="submit"
              style={{
                marginTop: 20,
                width: 150,
                height: 40,
              }}
            >
              {_("Send")}
            </Button>
          </RowContainer>
          <span id="errorMessage" style={{ color: "#c00000" }}></span>
        </form>
      </FormWrapper>
    </Container>
  );
}

SendForm.propTypes = {
  url: PropTypes.string,
};

SendForm.defaultProps = {
  url: `${process.env.GATSBY_WORDPRESS_URL}/wp-json/contact-form-7/v1/contact-forms/5/feedback`,
};
